import React from 'react';
import { BottomNavigation, BottomNavigationAction } from '@mui/material';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import YouTubeIcon from '@mui/icons-material/YouTube';
import AppShortcutIcon from '@mui/icons-material/AppShortcut'; // ícono para "Aplicación"
import { useNavigate } from 'react-router-dom';

const FooterNavigation = () => {
  const navigate = useNavigate();

  return (
    <BottomNavigation
      showLabels
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        backgroundColor: '#04305a',
        borderTop: '1px solid #02243f',
        zIndex: 10,
      }}
    >
      <BottomNavigationAction
        label="Ligas"
        icon={<SportsSoccerIcon />}
        sx={{ color: 'white' }}
        onClick={() => navigate('/ligas')}
      />
      <BottomNavigationAction
        label="Transmisiones"
        icon={<LiveTvIcon />}
        sx={{ color: 'white' }}
        onClick={() => navigate('/transmisiones')}
      />
      <BottomNavigationAction
        label="YouTube"
        icon={<YouTubeIcon />}
        sx={{ color: 'white' }}
        onClick={() => window.open('https://www.youtube.com/@AzulDirecta', '_blank')}
      />
      <BottomNavigationAction
        label="Aplicación"
        icon={<AppShortcutIcon />}
        sx={{ color: 'white' }}
        onClick={() => navigate('/falta1/login')}
      />
    </BottomNavigation>
  );
};

export default FooterNavigation;
